import type { BuildStatus } from '@/types/entities';
import { Badge } from '@/components/ui/badge';
import { Clock, Loader2, CheckCircle, XCircle } from 'lucide-react';

interface BuildStatusBadgeProps {
  status: BuildStatus;
  className?: string;
}

const statusConfig = {
  pending: { label: 'Pending', icon: Clock, variant: 'secondary' as const },
  running: { label: 'Building', icon: Loader2, variant: 'default' as const },
  success: { label: 'Published', icon: CheckCircle, variant: 'default' as const },
  failed: { label: 'Failed', icon: XCircle, variant: 'destructive' as const },
};

export function BuildStatusBadge({ status, className }: BuildStatusBadgeProps) {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={className}>
      <Icon className="size-3 mr-1" />
      {config.label}
    </Badge>
  );
}
